/* global axios */
import ApiClient from '../ApiClient';

class AssistantUsage extends ApiClient {
  constructor() {
    super('assistant/usage', { accountScoped: true });
  }

  get({ groupBy = 'day', since, until } = {}) {
    return axios.get(this.url, {
      params: {
        group_by: groupBy,
        since,
        until,
      },
    });
  }

  // Р63: построчная расшифровка тарифицируемых клиентов за период —
  // клиника выгружает её и сверяет со своей базой при проверке счёта.
  clients({ since, until } = {}) {
    return axios.get(`${this.url}/clients`, { params: { since, until } });
  }

  // Р74: статистика по ДИАЛОГАМ — начатые, уникальные и обращения (переписка,
  // разрезанная по паузе тишины). По ней владелец считает счёт вместо клиентов.
  conversations({ since, until, sessionGapHours } = {}) {
    return axios.get(`${this.url}/conversations`, {
      params: { since, until, session_gap_hours: sessionGapHours },
    });
  }

  // Построчная выгрузка диалогов за период — для сверки счёта.
  dialogues({ since, until, sessionGapHours } = {}) {
    return axios.get(`${this.url}/dialogues`, {
      params: { since, until, session_gap_hours: sessionGapHours },
    });
  }
}

export default new AssistantUsage();
